import { Tooltip } from "antd";
import React from "react";
import { makeClassParentsOptions } from "src/business/classes/labels";
import { ZSidLabel } from "src/types";

export const makeHierarchicalLabel = (
  parents: ZSidLabel[][] | null | undefined,
  label: string,
): string => {
  if (!parents || parents.length === 0) return label;
  return parents
    .filter((parent) => parent.length > 0)
    .map((parent) => [...parent.map((item) => item.label), label].join("/"))
    .join(" | ");
};

type PropsSysParentsColumn = {
  parents?: ZSidLabel[][] | null;
};

export const SysParentsColumn: React.FC<PropsSysParentsColumn> = ({
  parents,
}) => {
  const options = makeClassParentsOptions(parents || []);
  const firstOpt = options[0];
  if (!firstOpt) return "-";
  const optCount = options.length;
  if (optCount > 1)
    return (
      <Tooltip
        title={options.map((opt) => (
          <div key={opt.id}>{opt.label}</div>
        ))}
      >
        {firstOpt?.label} + ({optCount - 1})
      </Tooltip>
    );
  return firstOpt?.label;
};
